import React from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "../ui/dialog";
import { Button } from "../ui/button";
import { ChatWindow, ChatMessageData } from "./ChatWindow";
import { ChatInput } from "./ChatInput";
import { Bot, RotateCcw } from "lucide-react";

interface ChatDialogProps {
  isOpen: boolean;
  onClose: () => void;
  messages: ChatMessageData[];
  onSendMessage: (message: string) => void;
  onClearConversation?: () => void;
  isLoading?: boolean;
}

export function ChatDialog({
  isOpen,
  onClose,
  messages,
  onSendMessage,
  onClearConversation,
  isLoading = false,
}: ChatDialogProps) {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent
        className="sm:max-w-[500px] h-[600px] p-0 flex flex-col fixed bottom-20 right-6 top-auto left-auto translate-x-0 translate-y-0"
      >
        <DialogHeader className="px-4 py-3 border-b flex-shrink-0">
          <div className="flex items-center justify-between">
            <DialogTitle className="flex items-center gap-2">
              <Bot className="h-5 w-5 text-accent" />
              <span>AI Assistant</span>
            </DialogTitle>
            {onClearConversation && (
              <Button
                variant="ghost"
                size="sm"
                onClick={onClearConversation}
                className="h-8 text-xs"
                title={messages.length > 0 ? "Start a new conversation" : "Reset conversation thread"}
                disabled={isLoading}
              >
                <RotateCcw className="h-3 w-3 mr-1" />
                {messages.length > 0 ? "Clear" : "Reset"}
              </Button>
            )}
          </div>
        </DialogHeader>
        
        <ChatWindow
          messages={messages}
          isLoading={isLoading}
          className="flex-1 min-h-0"
        />
        
        <ChatInput
          onSend={onSendMessage}
          isLoading={isLoading}
        />
      </DialogContent>
    </Dialog>
  );
}

